import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";

import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";
import ChatLayout from "layouts/Chat.js";
import ChatPage from "views/ChatPage.js"

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <Routes>
      {/* 기본 루트 */}
      <Route path="*" element={<Navigate to="/auth/login" replace />} />

      <Route path="/admin/*" element={<AdminLayout />} />
      <Route path="/auth/*" element={<AuthLayout />} />
      <Route path="/chatbot/*" element={<ChatLayout />} />
      <Route path="/chatbot/chatPage" element={<ChatPage />} />

    </Routes>
  </BrowserRouter>
);
